import { render, staticRenderFns } from "./ThreatLogItem.vue?vue&type=template&id=a837e938"
import script from "./ThreatLogItem.vue?vue&type=script&lang=js"
export * from "./ThreatLogItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports